import { forEachSchemaNode, yup } from '@framework/validation';
import { set } from 'lodash';
import { IAdvancedRichText } from '../../inputs/rich-text-advanced/IAdvancedRichText';
import { replaceRichTextReferences } from '../../inputs/rich-text-advanced/render/postprocess-html/replaceRichTextReferences';
import { isRichTextSchema } from '../../inputs/rich-text-advanced/schema/RichTextAdvancedMeta';
import { isExpressionValueActive } from '../../schema/expressions/evaluate/getExpressionValue';
import { materializeReference } from '../../schema/expressions/evaluate/materializeReferencePath';
import { formatReferenceValue } from '../../schema/expressions/references/display/formatReferenceValue';
import { IWidgetType } from '../../schema/widgets/IWidgetType';
import { Widget } from '../../schema/widgets/Widget';
import { IHydrationContext } from '../IHydrationContext';
import { getHydratedReferenceValue } from '../expression/getHydratedReferenceValue';
import { hydrateExpressionValue } from '../expression/hydrateExpressionValue';

export function hydrateRichTexts<T extends Widget>(
  context: IHydrationContext,
  widgetType: IWidgetType<T>,
  widget: T,
  widgetFormName: string,
) {
  if (!widgetType.configValidator) return null;

  const WidgetConfigSchema = widgetType.configValidator.shape({
    // Saltiamo i figli, vengono già processati in `hydrateEngineWidget`
    // quando facciamo la ricorsione sui figli
    children: yup.mixed(),
  });

  forEachSchemaNode(WidgetConfigSchema, { value: widget }, node => {
    if (!isRichTextSchema(node.schema) || node.value == null) return;

    const value = node.value as IAdvancedRichText;

    const visibleItems = value
      .filter(item =>
        isExpressionValueActive(
          hydrateExpressionValue(context, widgetFormName, item.rule),
        ),
      )
      .map(item => ({
        ...item,
        text: hydrateRichTextItem(item.text, context, widgetFormName),
      }));

    if (!node.path) {
      console.warn(`[hydrateRichTexts] node.path is undefined`, node);
      return;
    }

    set(widget, node.path, visibleItems);
  });
}

function hydrateRichTextItem(
  text: string | null | undefined,
  context: IHydrationContext,
  widgetFormName: string,
) {
  return replaceRichTextReferences(text, ref => {
    const materializedRef = materializeReference(ref, widgetFormName);
    const hydratedRef = getHydratedReferenceValue(context, materializedRef);
    const formattedRef = formatReferenceValue(materializedRef, hydratedRef);

    return formattedRef;
  });
}
